import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const Close = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" ref={ref} {...props}>
    <g strokeLinecap="round" strokeLinejoin="round">
      <path d="M18.754 5.25 5.25 18.753M18.754 18.753 5.25 5.25" />
    </g>
  </svg>);
export default Close;